var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49115 0.716053C1.49125 0.716171 1.49137 0.716301 1.00043 1.16732C0.509481 1.61833 0.50962 1.61849 0.509771 1.61865L0.511025 1.62001L0.513586 1.62278L0.521736 1.63152C0.528506 1.63876 0.537942 1.64877 0.549973 1.66137C0.574032 1.68657 0.608498 1.72216 0.652815 1.76666C0.741403 1.85561 0.869629 1.98043 1.03304 2.12914C1.35921 2.42595 1.82912 2.82121 2.40709 3.21726C3.54845 3.99937 5.18292 4.83398 7.00043 4.83398C8.81794 4.83398 10.4524 3.99937 11.5938 3.21726C12.1717 2.82121 12.6416 2.42595 12.9678 2.12914C13.1312 1.98043 13.2595 1.85561 13.348 1.76666C13.3924 1.72216 13.4268 1.68657 13.4509 1.66137C13.4629 1.64877 13.4723 1.63876 13.4791 1.63152L13.4873 1.62278L13.4898 1.62001L13.4907 1.61904C13.4909 1.61887 13.4914 1.61833 13.0004 1.16732C12.5095 0.716301 12.5096 0.716171 12.5097 0.716053L12.5057 0.720323L12.4865 0.74065C12.4686 0.759395 12.4407 0.788255 12.4033 0.825787C12.3285 0.900897 12.2161 1.01046 12.0704 1.143C11.7785 1.40869 11.3566 1.76342 10.8401 2.11738C9.79244 2.83527 8.42691 3.50065 7.00043 3.50065C5.57394 3.50065 4.20841 2.83527 3.16077 2.11738C2.64423 1.76342 2.2224 1.40869 1.93044 1.143C1.78479 1.01046 1.67236 0.900897 1.59756 0.825787C1.56018 0.788255 1.53226 0.759395 1.51437 0.74065L1.49513 0.720323L1.49115 0.716053Z",
    fill: "#404F55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66732 7.16699V4.16699H6.33398V7.16699H7.66732Z",
    fill: "#404F55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47211 5.97168L4.47211 3.97168L3.5293 3.02887L1.5293 5.02887L2.47211 5.97168Z",
    fill: "#404F55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5289 5.97168L9.52887 3.97168L10.4717 3.02887L12.4717 5.02887L11.5289 5.97168Z",
    fill: "#404F55"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassHide);
export default __webpack_public_path__ + "static/media/passHide.56b812b322fefbc4e11f100fdd99f6c5.svg";
export { ForwardRef as ReactComponent };